import { createColumn, defaultColumns, relationField } from '../_defaults/columns'

export const columns = [
  createColumn({
    label: 'Person',
    field: 'personId',
    ...relationField({
      type: 'one',
      namespace: 'event',
      filterIs: 'text-filter'
    })
  }),
  createColumn({
    label: 'Email Subscription',
    field: 'emailSubscriptionId',
    ...relationField({
      type: 'one',
      namespace: 'emailSubcription',
      filterIs: 'text-filter'
    })
  })
].concat(defaultColumns)
